import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "../../shared/services/auth.service";
import { AdminSeafLoadingService } from "../../shared/services/adminseaf-loading.service";
const Swal = require('sweetalert2');

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  public show: boolean = false;
  public loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private loadingService: AdminSeafLoadingService
  ) {
    this.loginForm = this.fb.group({
      email: ["", Validators.required],
      password: ["", Validators.required],
    });
  }

  ngOnInit() {
   // this.loadingService.mostrar("Iniciando...");
  }

  login() {
    if (this.loginForm.invalid) return;
    this.loadingService.mostrar("Preparando tu entorno de trabajo...");
    this.loading = true;

    this.authService.login(
      this.loginForm.value["email"],
      this.loginForm.value["password"]
    ).subscribe({
      next: (user) => {
       // console.log('✅ Login exitoso, redirigiendo...');
       // console.log("✅ Usuario autenticado:", user.usuario.roles);
       this.loadingService.ocultar();
       this.loading = false;
        
        // Verificar roles de tenant
        if(user.usuario.roles.includes('USUARIO_TENANT', "USUARIO_TENANT_FUEC") ){
          this.router.navigate(['elaborar/elaborar']);
        } else {
          if(user.usuario.roles.includes('ADMIN')){
            this.router.navigate(['/dashboard/default']);
          }
        }
      },
      error: (error) => {
        this.loadingService.ocultar();
        this.loading = false;
        const errorMessage = error.error?.message || 'Ocurrió un error inesperado.';

        Swal.fire({
          icon: 'error',
          title: 'Error de autenticación',
          text: errorMessage,
          confirmButtonText: 'Aceptar',
        });
      }
    });
  }

  showPassword() {
    this.show = !this.show;
  }
}
